import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'app/main/services/app.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export const LocalStorageFilterLangKey = 'locale';

@Component({
	selector: 'language-switcher',
	templateUrl: './language-switcher.component.html',
	styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {

	_unsubscribeAll: Subject<any>;

	constructor(public appService: AppService, public translate: TranslateService) {
		this._unsubscribeAll = new Subject<any>();
	}

	ngOnInit(): void {}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	onChange(event: any): void{
		let lang = '';
		if(event instanceof Event){
			const input = <HTMLInputElement>event.target;
			lang = input.value;
		} else lang = event;
		this.appService.languageChanging.next(true);
		this.appService.languageChange(lang)
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				localStorage.setItem('locale', lang);
				this.translate.use(lang).subscribe(() => {
					this.appService.onLanguageChange.emit(lang);
					this.appService.languageChanging.next(false);
				});
			},
			error: message => {
				// catch error
				this.appService.onLanguageChange.emit(lang);
				this.appService.languageChanging.next(false);
			}
		});
	}
}
